// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-20a5b6f0].require> .el-input__inner{\r\n  border: red 1px solid;\n}\r\n", ""]);
// Exports
module.exports = exports;
